import React, { useEffect, useState } from 'react';
import { useSetDisplayName, useSetOnboardingStage, useDisplayName } from '../state';
import fetchWithToken, { updateOnboardingStage } from '../services';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';
import { AUTH_ROUTES, ONBOARDING_ROUTES, GENERAL_ROUTES } from '../constants/routes';

const EnterDisplayName = () => {
    const setDisplayName = useSetDisplayName();
    const setOnboardingStage = useSetOnboardingStage();
    const currentDisplayName = useDisplayName();
    const [isLoading, setIsLoading] = useState(false);
    const [inputValue, setInputValue] = useState(currentDisplayName || '');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const updateDisplayName = async (name) => {
        try {
            const response = await fetchWithToken('/update-display-name', {
                method: 'PATCH',
                body: JSON.stringify({ name }),
            });

            if (!response.ok) {
                if (response.status === 422) {
                  setErrorMessage('Display name violates our content policy. Please choose another name.');
                  setIsLoading(false);
                  return false;
                } else {
                  throw new Error('Failed to update display name.');
                }
              }
            return true;
        } catch (error) {
            console.error('Failed to update display name:', error);
            setErrorMessage('We weren\'t able to update your display name at this time. Please try again later.');
            throw error;
        }
    };

    const handleSubmit = async (event) => {
        setIsLoading(true);
        event.preventDefault();
        try {
            const ok = await updateDisplayName(inputValue);
            if (ok === false) {
                // 422 violation was handled (error message set, loading stopped). Do not proceed.
                return;
            }

            setDisplayName(inputValue);

            // Update onboarding stage
            await updateOnboardingStage('enter-link-id');
            setOnboardingStage('enter-link-id');

            setIsLoading(false);
            navigate(ONBOARDING_ROUTES.ENTER_LINK_ID);
        } catch (error) {
            console.error('Failed to update display name:', error);
            setIsLoading(false);
            navigate(GENERAL_ROUTES.ERROR);
        }
    };

    const handleChange = (event) => {
        setInputValue(event.target.value);
    };

    if (isLoading) return <Loading />;

    return (
        <div className="flex flex-col items-center justify-center min-h-[calc(100vh)]">
            <div className="flex flex-col items-center">
                <form onSubmit={handleSubmit} className="flex flex-col items-center space-y-5 w-full max-w-lg">
                    <label className="text-white text-center">
                        What name would you like your supporters to see when they tip you?
                    </label>
                    <input
                        type="text"
                        name="displayName"
                        value={inputValue}
                        onChange={handleChange}
                        className="w-72 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-black text-center"
                    />
                    {errorMessage && <div className="text-red-500 text-sm text-center">{errorMessage}</div>}
                    <div className="flex justify-center">
                        <button
                            type="submit"
                            className="bg-green-400 text-white px-4 py-2 rounded-md hover:bg-green-500 transition duration-300"
                            disabled={isLoading}
                        >
                            Next
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EnterDisplayName;
